// export const API_BASE_URL = "https://www.designcraft.ae/admin/api/";
// export const UPLOADS_BASE_URL = "https://www.designcraft.ae/admin/uploads/";

export const API_BASE_URL = "https://designcraft.ae/api/";
export const UPLOADS_BASE_URL = "https://designcraft.ae/api/uploads/";

// Instagram API Configuration
// export const INSTAGRAM_CONFIG = {
//   ACCESS_TOKEN: '6ad96e5670e7dcba003ed8d4fa32d1ee',  // Real Instagram access token
//   ACCOUNT_ID: '1393028551808588',  // Instagram account ID for Designcraft_Feeds-IG
//   ACCOUNT_USERNAME: 'designcraft.ae',
//   ACCOUNT_URL: 'https://www.instagram.com/designcraft.ae/',
//   DEFAULT_LIMIT: 6,  // Increased to show more posts
  
//   // API settings - Try different endpoints
//   API_BASE_URL: 'https://graph.instagram.com',
  
//   // Fields to fetch from Instagram API
//   FIELDS: 'id,caption,media_type,media_url,thumbnail_url,permalink,timestamp',
  
//   // Cache settings (in milliseconds)
//   CACHE_DURATION: 30 * 60 * 1000, // 30 minutes
// };

// Helper function to check if Instagram is properly configured
// export const isInstagramConfigured = () => {
//   const isConfigured = !!(
//     INSTAGRAM_CONFIG.ACCESS_TOKEN && 
//     INSTAGRAM_CONFIG.ACCESS_TOKEN.length > 0 && 
//     INSTAGRAM_CONFIG.ACCESS_TOKEN !== 'your_instagram_access_token_here' &&
//     INSTAGRAM_CONFIG.ACCOUNT_ID
//   );
//   console.log('Instagram configured check:', {
//     hasToken: !!INSTAGRAM_CONFIG.ACCESS_TOKEN,
//     tokenLength: INSTAGRAM_CONFIG.ACCESS_TOKEN?.length,
//     tokenValue: INSTAGRAM_CONFIG.ACCESS_TOKEN, // Show token for debugging
//     hasAccountId: !!INSTAGRAM_CONFIG.ACCOUNT_ID,
//     accountId: INSTAGRAM_CONFIG.ACCOUNT_ID,
//     isConfigured
//   });
//   return isConfigured;
// };

// Function to get Instagram API URL - Try different approaches
// export const getInstagramApiUrl = (limit = INSTAGRAM_CONFIG.DEFAULT_LIMIT) => {
//   if (!INSTAGRAM_CONFIG.ACCESS_TOKEN) {
//     throw new Error('Instagram access token not configured');
//   }
  
//   // Try different API endpoints based on token type
//   const urls = [
//     // Method 1: User's media with account ID (current)
//     `${INSTAGRAM_CONFIG.API_BASE_URL}/${INSTAGRAM_CONFIG.ACCOUNT_ID}/media?fields=${INSTAGRAM_CONFIG.FIELDS}&access_token=${INSTAGRAM_CONFIG.ACCESS_TOKEN}&limit=${limit}`,
    
//     // Method 2: Direct me endpoint (for user tokens)
//     `${INSTAGRAM_CONFIG.API_BASE_URL}/me/media?fields=${INSTAGRAM_CONFIG.FIELDS}&access_token=${INSTAGRAM_CONFIG.ACCESS_TOKEN}&limit=${limit}`,
    
//     // Method 3: Instagram Basic Display API
//     `${INSTAGRAM_CONFIG.API_BASE_URL}/v12.0/me/media?fields=${INSTAGRAM_CONFIG.FIELDS}&access_token=${INSTAGRAM_CONFIG.ACCESS_TOKEN}&limit=${limit}`
//   ];
  
//   return urls[0]; // Start with first method
// };

